<template>
  <div class="p-2">
    <ve-table :columns="columns" :table-data="tableData" />
    <div class="flex justify-end p-5 w-full gap-5">
       <button class="bg-white border-1.5  rounded-full px-10 text-sm  py-2">
        Add
      </button>
      <button class="bg-primary rounded-full px-10 text-sm text-white py-2">
        Save
      </button>
    </div>
  </div>
</template>



<script>
export default {
  name: "Checklist",
  data() {
    return {
      columns: [
        {
          field: "",
          key: "numbering",
          title: "",
          width: 10,
          align: "center",
          renderBodyCell: ({ rowIndex }) => {
            return ++rowIndex;
          },
        },

        { field: "ToDo", key: "a", title: "To Do" },
        { field: "AssignedTo", key: "b", title: "Assigned To" },
        { field: "Deadline", key: "c", title: "Deadline" },
        {
          field: "Progress",
          key: "x",
          title: "Progress",
        },
        {
          field: "Action",
          key: "f",
          title: "Action",
          renderBodyCell: () => {
            return (
              <p class="cursor-pointer transform rotate-90 font-bold">
                &#8230;
              </p>
            );
          },
        },
      ],
      tableData: [
        {
          ToDo: "Create Work Email",
          AssignedTo: "Lilian Doe",
          Deadline: "All",
          Progress: "In Progress",
          Action: "Approved",
        },
        {
          ToDo: "Create Work Email",
          AssignedTo: "Lilian Doe",
          Deadline: "All",
          Progress: "In Progress",
          Action: "Approved",
        },
        {
          ToDo: "Create Work Email",
          AssignedTo: "Lilian Doe",
          Deadline: "All",
          Progress: "In Progress",
          Action: "Approved",
        },
        {
          ToDo: "Create Work Email",
          AssignedTo: "Lilian Doe",
          Deadline: "All",
          Progress: "In Progress",
          Action: "Approved",
        },
        {
          ToDo: "Create Work Email",
          AssignedTo: "Lilian Doe",
          Deadline: "All",
          Progress: "In Progress",
          Action: "Approved",
        },
        {
          ToDo: "Create Work Email",
          AssignedTo: "Lilian Doe",
          Deadline: "All",
          Progress: "In Progress",
          Action: "Approved",
        },
      ],
    };
  },
};
</script>
